<template>
  <div>
    <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.addYt', '添加议题')" width="1560px" :visible.sync="dialogVisible" :fullscreen="fullscreen" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
      <template slot="title">
        <span class="dialog-title">{{ $tx('hygl.components.addYt', '添加议题') }}</span>
        <span class="dialog-title-right" style="float: right;margin-right: 25px;margin-top: 2px;" @click="fullScreenClick">
          <i class="el-icon-full-screen" style="font-size:19px;color:#909399"></i>
        </span>
      </template>
      <div>
        <div class="dialog_top">
          <span v-text-lbl="'hygl.components.zjDept'">征集部门：</span>
          <el-input v-model="searchObj.dept" style="width: 250px" size="small" :placeholder="$tx('hygl.hyyt.pleaseIput', '请输入')"></el-input>
          <span v-text-lbl="'hygl.ytRecord.subject'" style="margin-left: 10px">会议议题：</span>
          <el-input v-model="searchObj.title" style="width: 250px" size="small" :placeholder="$tx('hygl.hyyt.pleaseIput', '请输入')"></el-input>
          <el-button v-pageBtn-lbl="'search'" type="primary" size="small" @click="searchHandle">查询</el-button>
        </div>
        <el-table ref="table" v-loading="loading" :data="tableData" border class="jxzb-tables" @selection-change="selectionChange">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
          <el-table-column prop="subject" :label="$tx('hygl.components.meetingAgenda', '会议议题')" min-width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="subjectTypeName" :label="$tx('hygl.components.meetingType', '会议类型')" width="160" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="mainDept" :label="$tx('hygl.components.hostDepartment', '主办部门')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="reportPersonName" :label="$tx('hygl.components.declarant', '陈述人')" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="reportTime" :label="$tx('hygl.components.csTime', '陈述时间/分钟')" width="150" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="talkTime" :label="$tx('hygl.components.talkTime', '讨论时间/分钟')" width="150" :show-overflow-tooltip="true" align="center"></el-table-column>
          <!-- <el-table-column prop="attendDept" :label="$tx('hygl.components.attendDept', '列席部门')" width="200" :show-overflow-tooltip="true" align="left"></el-table-column> -->
          <el-table-column prop="generateType" :label="$tx('hygl.ytRecord.generateType', '议题来源')" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="createDate" :label="$tx('hygl.ytRecord.createDate', '创建时间')" width="170" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.createDate | timeFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" :label="$tx('hygl.ytRecord.endTime', '征集结束时间')" width="170" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime | timeFormat }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="attachCount" :label="$tx('hygl.ytRecord.attachCount', '附件数')" width="60" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.passenger.attachCount | '无' }}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'cancel'" @click="toClose">取 消</el-button>
        <el-button v-pageBtn-lbl="'sure'" type="primary" @click="submitHandle">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        }
    },
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            searchObj: {
                dept: '',
                title: ''
            },
            loading: false,
            selectList: [],
            fullscreen: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openOvertimeIssue', this.openOvertimeIssue)
    },
    beforeDestroy() {
        this.$bus.off('openOvertimeIssue', this.openOvertimeIssue)
    },
    mounted() {},
    methods: {
        openOvertimeIssue() {
            this.getTableData()
        },
        getTableData() {
            this.loading = true
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/hygl/deptytRecord/listdata?filter=timeout`,
                method: 'POST',
                params: {
                    listpageViewUrl: 'hygl.deptytRecord.list_timeout.vue',
                    urlsearch: `mainDept like ${this.searchObj.dept};subject like ${this.searchObj.title}`
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.tableData = res.body.pageInfo.list
                    this.dialogVisible = true
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        selectionChange(val) {
            this.selectList = val
        },
        // 搜索
        searchHandle() {
            this.getTableData()
        },
        // 确认
        submitHandle() {
            if (!this.selectList.length) {
                this.$message({ message: this.$tx('hygl.message.selectYt', '请选择议题。'), type: 'warning' })
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/hygl/ytRecord/adYtSubmitted`,
                method: 'POST',
                data: this.selectList
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.$bus.emit('refreshListData')
                    this.dialogVisible = false
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        // 全屏
        fullScreenClick() {
            this.fullscreen = !this.fullscreen
            this.$forceUpdate()
        },
        // 关闭
        toClose() {
            this.loading = false
            this.tableData = []
            this.searchObj = {
                dept: '',
                title: ''
            }
            this.fullscreen = false
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.dialog-title-right {
    cursor: pointer;
}
</style>
